{
  "schemaVersion": 1,
  "evidence": "Original archive sound samples. Weapon / action sound ids agree in the pinned Gunny 3.0 and DDTank-II BallList archives. Audio banks are later/source candidates; exact 2009 audio capture remains unverified.",
  "weapons": {
    "bombpack": {
      "normal": {
        "ballId": "161",
        "actionType": 0,
        "shootSoundId": "025",
        "impactSoundId": "087",
        "shoot": "/game/audio/weapon-sounds/Sound025.mp3",
        "impact": "/game/audio/weapon-sounds/Sound087.mp3"
      },
      "special": {
        "ballId": "171",
        "actionType": 0,
        "shootSoundId": "083",
        "impactSoundId": "088",
        "shoot": "/game/audio/weapon-sounds/Sound083.mp3",
        "impact": "/game/audio/weapon-sounds/Sound088.mp3"
      }
    },
    "bomb": {
      "normal": {
        "ballId": "101",
        "actionType": 1,
        "shootSoundId": "023",
        "impactSoundId": "087",
        "shoot": "/game/audio/weapon-sounds/Sound023.mp3",
        "impact": "/game/audio/weapon-sounds/Sound087.mp3"
      },
      "special": {
        "ballId": "111",
        "actionType": 1,
        "shootSoundId": "069",
        "impactSoundId": "088",
        "shoot": "/game/audio/weapon-sounds/Sound069.mp3",
        "impact": "/game/audio/weapon-sounds/Sound088.mp3"
      }
    },
    "dart": {
      "normal": {
        "ballId": "121",
        "actionType": 0,
        "shootSoundId": "029",
        "impactSoundId": "089",
        "shoot": "/game/audio/weapon-sounds/Sound029.mp3",
        "impact": "/game/audio/weapon-sounds/Sound089.mp3"
      },
      "special": {
        "ballId": "131",
        "actionType": 0,
        "shootSoundId": "079",
        "impactSoundId": "090",
        "shoot": "/game/audio/weapon-sounds/Sound079.mp3",
        "impact": "/game/audio/weapon-sounds/Sound090.mp3"
      }
    },
    "electricbar": {
      "normal": {
        "ballId": "141",
        "actionType": 1,
        "shootSoundId": "035",
        "impactSoundId": "091",
        "shoot": "/game/audio/weapon-sounds/Sound035.mp3",
        "impact": "/game/audio/weapon-sounds/Sound091.mp3"
      },
      "special": {
        "ballId": "151",
        "actionType": 1,
        "shootSoundId": "081",
        "impactSoundId": "092",
        "shoot": "/game/audio/weapon-sounds/Sound081.mp3",
        "impact": "/game/audio/weapon-sounds/Sound092.mp3"
      }
    },
    "brick": {
      "normal": {
        "ballId": "381",
        "actionType": 0,
        "shootSoundId": "116",
        "impactSoundId": "107",
        "shoot": "/game/audio/weapon-sounds/Sound116.mp3",
        "impact": "/game/audio/weapon-sounds/Sound107.mp3"
      },
      "special": {
        "ballId": "391",
        "actionType": 0,
        "shootSoundId": "113",
        "impactSoundId": "105",
        "shoot": "/game/audio/weapon-sounds/Sound113.mp3",
        "impact": "/game/audio/weapon-sounds/Sound105.mp3"
      }
    },
    "fruit": {
      "normal": {
        "ballId": "401",
        "actionType": 0,
        "shootSoundId": "114",
        "impactSoundId": "102",
        "shoot": "/game/audio/weapon-sounds/Sound114.mp3",
        "impact": "/game/audio/weapon-sounds/Sound102.mp3"
      },
      "special": {
        "ballId": "411",
        "actionType": 0,
        "shootSoundId": "114",
        "impactSoundId": "101",
        "shoot": "/game/audio/weapon-sounds/Sound114.mp3",
        "impact": "/game/audio/weapon-sounds/Sound101.mp3"
      }
    },
    "OPSbox": {
      "normal": {
        "ballId": "341",
        "actionType": 0,
        "shootSoundId": "111",
        "impactSoundId": "103",
        "shoot": "/game/audio/weapon-sounds/Sound111.mp3",
        "impact": "/game/audio/weapon-sounds/Sound103.mp3"
      },
      "special": {
        "ballId": "351",
        "actionType": 0,
        "shootSoundId": "112",
        "impactSoundId": "104",
        "shoot": "/game/audio/weapon-sounds/Sound112.mp3",
        "impact": "/game/audio/weapon-sounds/Sound104.mp3"
      }
    },
    "closestool": {
      "normal": {
        "ballId": "361",
        "actionType": 1,
        "shootSoundId": "115",
        "impactSoundId": "106",
        "shoot": "/game/audio/weapon-sounds/Sound115.mp3",
        "impact": "/game/audio/weapon-sounds/Sound106.mp3"
      },
      "special": {
        "ballId": "371",
        "actionType": 1,
        "shootSoundId": "108",
        "impactSoundId": "098",
        "shoot": "/game/audio/weapon-sounds/Sound108.mp3",
        "impact": "/game/audio/weapon-sounds/Sound098.mp3"
      }
    },
    "television": {
      "normal": {
        "ballId": "321",
        "actionType": 0,
        "shootSoundId": "110",
        "impactSoundId": "100",
        "shoot": "/game/audio/weapon-sounds/Sound110.mp3",
        "impact": "/game/audio/weapon-sounds/Sound100.mp3"
      },
      "special": {
        "ballId": "331",
        "actionType": 0,
        "shootSoundId": "109",
        "impactSoundId": "099",
        "shoot": "/game/audio/weapon-sounds/Sound109.mp3",
        "impact": "/game/audio/weapon-sounds/Sound099.mp3"
      }
    },
    "axe": {
      "normal": {
        "ballId": "20",
        "actionType": 0,
        "shootSoundId": "033",
        "impactSoundId": "095",
        "shoot": "/game/audio/weapon-sounds/Sound033.mp3",
        "impact": "/game/audio/weapon-sounds/Sound095.mp3"
      },
      "special": {
        "ballId": "21",
        "actionType": 0,
        "shootSoundId": "075",
        "impactSoundId": "095",
        "shoot": "/game/audio/weapon-sounds/Sound075.mp3",
        "impact": "/game/audio/weapon-sounds/Sound095.mp3"
      }
    },
    "bow": {
      "normal": {
        "ballId": "18",
        "actionType": 1,
        "shootSoundId": "021",
        "impactSoundId": "094",
        "shoot": "/game/audio/weapon-sounds/Sound021.mp3",
        "impact": "/game/audio/weapon-sounds/Sound094.mp3"
      },
      "special": {
        "ballId": "19",
        "actionType": 1,
        "shootSoundId": "073",
        "impactSoundId": "094",
        "shoot": "/game/audio/weapon-sounds/Sound073.mp3",
        "impact": "/game/audio/weapon-sounds/Sound094.mp3"
      }
    },
    "gun": {
      "normal": {
        "ballId": "22",
        "actionType": 1,
        "shootSoundId": "031",
        "impactSoundId": "087",
        "shoot": "/game/audio/weapon-sounds/Sound031.mp3",
        "impact": "/game/audio/weapon-sounds/Sound087.mp3"
      },
      "special": {
        "ballId": "23",
        "actionType": 1,
        "shootSoundId": "071",
        "impactSoundId": "088",
        "shoot": "/game/audio/weapon-sounds/Sound071.mp3",
        "impact": "/game/audio/weapon-sounds/Sound088.mp3"
      }
    },
    "goldgun": {
      "normal": {
        "ballId": "30",
        "actionType": 1,
        "shootSoundId": "031",
        "impactSoundId": "087",
        "shoot": "/game/audio/weapon-sounds/Sound031.mp3",
        "impact": "/game/audio/weapon-sounds/Sound087.mp3"
      },
      "special": {
        "ballId": "31",
        "actionType": 1,
        "shootSoundId": "071",
        "impactSoundId": "088",
        "shoot": "/game/audio/weapon-sounds/Sound071.mp3",
        "impact": "/game/audio/weapon-sounds/Sound088.mp3"
      }
    },
    "axe3": {
      "normal": {
        "ballId": "28",
        "actionType": 0,
        "shootSoundId": "033",
        "impactSoundId": "095",
        "shoot": "/game/audio/weapon-sounds/Sound033.mp3",
        "impact": "/game/audio/weapon-sounds/Sound095.mp3"
      },
      "special": {
        "ballId": "29",
        "actionType": 0,
        "shootSoundId": "075",
        "impactSoundId": "095",
        "shoot": "/game/audio/weapon-sounds/Sound075.mp3",
        "impact": "/game/audio/weapon-sounds/Sound095.mp3"
      }
    },
    "bow3": {
      "normal": {
        "ballId": "42",
        "actionType": 1,
        "shootSoundId": "021",
        "impactSoundId": "094",
        "shoot": "/game/audio/weapon-sounds/Sound021.mp3",
        "impact": "/game/audio/weapon-sounds/Sound094.mp3"
      },
      "special": {
        "ballId": "43",
        "actionType": 1,
        "shootSoundId": "073",
        "impactSoundId": "094",
        "shoot": "/game/audio/weapon-sounds/Sound073.mp3",
        "impact": "/game/audio/weapon-sounds/Sound094.mp3"
      }
    }
  },
  "actions": {
    "fly": {
      "ballId": "3",
      "actionType": 0,
      "shootSoundId": "023",
      "impactSoundId": "096",
      "shoot": "/game/audio/weapon-sounds/Sound023.mp3",
      "impact": "/game/audio/weapon-sounds/Sound096.wav"
    },
    "ice": {
      "ballId": "1",
      "actionType": 0,
      "shootSoundId": "023",
      "impactSoundId": "093",
      "shoot": "/game/audio/weapon-sounds/Sound023.mp3",
      "impact": "/game/audio/weapon-sounds/Sound093.mp3"
    }
  },
  "ui": {
    "selfTurn": "/game/audio/weapon-sounds/Sound016.wav",
    "otherTurn": "/game/audio/weapon-sounds/Sound038.wav"
  },
  "sounds": {
    "016": {
      "url": "/game/audio/weapon-sounds/Sound016.wav",
      "duration": 1.304126984126984,
      "sampleRate": 44100,
      "seekSamples": null,
      "startOffset": 0.0
    },
    "021": {
      "url": "/game/audio/weapon-sounds/Sound021.mp3",
      "duration": 1.4529705215419502,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "023": {
      "url": "/game/audio/weapon-sounds/Sound023.mp3",
      "duration": 1.7208390022675737,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "025": {
      "url": "/game/audio/weapon-sounds/Sound025.mp3",
      "duration": 1.9715873015873016,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "029": {
      "url": "/game/audio/weapon-sounds/Sound029.mp3",
      "duration": 1.1800680272108843,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "031": {
      "url": "/game/audio/weapon-sounds/Sound031.mp3",
      "duration": 1.4899773242630385,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "033": {
      "url": "/game/audio/weapon-sounds/Sound033.mp3",
      "duration": 1.678390022675737,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "035": {
      "url": "/game/audio/weapon-sounds/Sound035.mp3",
      "duration": 1.573015873015873,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "038": {
      "url": "/game/audio/weapon-sounds/Sound038.wav",
      "duration": 0.8148299319727891,
      "sampleRate": 44100,
      "seekSamples": null,
      "startOffset": 0.0
    },
    "069": {
      "url": "/game/audio/weapon-sounds/Sound069.mp3",
      "duration": 1.1963718820861677,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "071": {
      "url": "/game/audio/weapon-sounds/Sound071.mp3",
      "duration": 1.0335600907029479,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "073": {
      "url": "/game/audio/weapon-sounds/Sound073.mp3",
      "duration": 1.8508390022675736,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "075": {
      "url": "/game/audio/weapon-sounds/Sound075.mp3",
      "duration": 1.7031292517006802,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "079": {
      "url": "/game/audio/weapon-sounds/Sound079.mp3",
      "duration": 1.0793877551020408,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "081": {
      "url": "/game/audio/weapon-sounds/Sound081.mp3",
      "duration": 1.2559410430839002,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "083": {
      "url": "/game/audio/weapon-sounds/Sound083.mp3",
      "duration": 1.1250340136054422,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "087": {
      "url": "/game/audio/weapon-sounds/Sound087.mp3",
      "duration": 1.9095464852607709,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "088": {
      "url": "/game/audio/weapon-sounds/Sound088.mp3",
      "duration": 2.4779591836734696,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "089": {
      "url": "/game/audio/weapon-sounds/Sound089.mp3",
      "duration": 0.777891156462585,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "090": {
      "url": "/game/audio/weapon-sounds/Sound090.mp3",
      "duration": 1.336893424036281,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "091": {
      "url": "/game/audio/weapon-sounds/Sound091.mp3",
      "duration": 0.9933560090702948,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "092": {
      "url": "/game/audio/weapon-sounds/Sound092.mp3",
      "duration": 1.160204081632653,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "093": {
      "url": "/game/audio/weapon-sounds/Sound093.mp3",
      "duration": 2.001269841269841,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "094": {
      "url": "/game/audio/weapon-sounds/Sound094.mp3",
      "duration": 1.6323809523809525,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "095": {
      "url": "/game/audio/weapon-sounds/Sound095.mp3",
      "duration": 1.243219954648526,
      "sampleRate": 44100,
      "seekSamples": 1677,
      "startOffset": 0.03802721088435374
    },
    "096": {
      "url": "/game/audio/weapon-sounds/Sound096.wav",
      "duration": 1.7066213151927438,
      "sampleRate": 22050,
      "seekSamples": null,
      "startOffset": 0.0
    },
    "098": {
      "url": "/game/audio/weapon-sounds/Sound098.mp3",
      "duration": 2.8365532879818596,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "099": {
      "url": "/game/audio/weapon-sounds/Sound099.mp3",
      "duration": 1.0878004535147392,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "100": {
      "url": "/game/audio/weapon-sounds/Sound100.mp3",
      "duration": 1.3793197278911564,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "101": {
      "url": "/game/audio/weapon-sounds/Sound101.mp3",
      "duration": 1.05578231292517,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "102": {
      "url": "/game/audio/weapon-sounds/Sound102.mp3",
      "duration": 1.8917006802721088,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "103": {
      "url": "/game/audio/weapon-sounds/Sound103.mp3",
      "duration": 0.7248072562358276,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "104": {
      "url": "/game/audio/weapon-sounds/Sound104.mp3",
      "duration": 0.4834467120181406,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "105": {
      "url": "/game/audio/weapon-sounds/Sound105.mp3",
      "duration": 1.0000907029478459,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "106": {
      "url": "/game/audio/weapon-sounds/Sound106.mp3",
      "duration": 0.7248072562358276,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "107": {
      "url": "/game/audio/weapon-sounds/Sound107.mp3",
      "duration": 0.8462585034013606,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "108": {
      "url": "/game/audio/weapon-sounds/Sound108.mp3",
      "duration": 0.7096598639455782,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "109": {
      "url": "/game/audio/weapon-sounds/Sound109.mp3",
      "duration": 0.9972789115646259,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "110": {
      "url": "/game/audio/weapon-sounds/Sound110.mp3",
      "duration": 0.9751473922902494,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "111": {
      "url": "/game/audio/weapon-sounds/Sound111.mp3",
      "duration": 0.4344671201814059,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "112": {
      "url": "/game/audio/weapon-sounds/Sound112.mp3",
      "duration": 0.4344671201814059,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "113": {
      "url": "/game/audio/weapon-sounds/Sound113.mp3",
      "duration": 0.9972789115646259,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "114": {
      "url": "/game/audio/weapon-sounds/Sound114.mp3",
      "duration": 0.8587755102040816,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "115": {
      "url": "/game/audio/weapon-sounds/Sound115.mp3",
      "duration": 0.31229024943310657,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    },
    "116": {
      "url": "/game/audio/weapon-sounds/Sound116.mp3",
      "duration": 0.9751473922902494,
      "sampleRate": 11025,
      "seekSamples": 1661,
      "startOffset": 0.15065759637188209
    }
  },
  "missing": []
}
